"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatureRegistry = void 0;
/**
 * Catalog of creature definitions.
 */
class CreatureRegistry {
    constructor(slots, origin = null) {
        this.slots = slots !== null && slots !== void 0 ? slots : new Map();
        this.origin = origin;
    }
    get size() {
        return this.slots.size;
    }
    get(id) {
        var _a;
        return (_a = this.slots.get(id)) === null || _a === void 0 ? void 0 : _a.definition;
    }
    has(id) {
        return this.slots.has(id);
    }
    /** Cross-plugin overwrite logs a warning, but the write still goes through. */
    set(id, definition) {
        if (!this.origin) {
            throw new Error("CreatureRegistry: cannot set on an unowned registry; use scopedTo() to create a plugin-owned registry");
        }
        const existing = this.slots.get(id);
        if (existing && existing.origin.plugin !== this.origin.plugin) {
            // eslint-disable-next-line no-console
            console.warn(`[creatures] id ${id} ("${existing.definition.name}") already registered by plugin "${existing.origin.plugin}"; ` +
                `overwriting with "${definition.name}" from plugin "${this.origin.plugin}". Asset URLs now resolve to the new owner.`);
        }
        this.slots.set(id, { definition, origin: this.origin });
    }
    originOf(id) {
        var _a, _b;
        return (_b = (_a = this.slots.get(id)) === null || _a === void 0 ? void 0 : _a.origin) !== null && _b !== void 0 ? _b : null;
    }
    *values() {
        for (const slot of this.slots.values()) {
            yield slot.definition;
        }
    }
    *entriesWithOrigin() {
        for (const slot of this.slots.values()) {
            yield Object.assign({}, slot);
        }
    }
    scopedTo(origin) {
        return new CreatureRegistry(this.slots, origin);
    }
}
exports.CreatureRegistry = CreatureRegistry;
